var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "rounded-lg" },
    [
      _c("v-card-title", [_vm._v(" Account ")]),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c("v-alert", { attrs: { type: "info", color: "primary" } }, [
            _vm._v(
              "Coming soon. Contact us if you need help with your account."
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }